import { PieCustomLayerProps } from "@nivo/pie";

import { useIsMobile } from "../../../hooks";
import { PieData } from "../../types";

export type ChartCenteredMetricProps = PieCustomLayerProps<PieData> & {
  label: string;
  total: number;
};

export const ChartCenteredMetric = ({
  centerX,
  centerY,
  total,
  label,
}: ChartCenteredMetricProps) => {
  const isMobile = useIsMobile();

  return (
    <text
      x={centerX}
      y={centerY}
      textAnchor="middle"
      dominantBaseline="central"
    >
      <tspan
        x={centerX}
        dy={isMobile ? "-12" : "-20"}
        fontSize={isMobile ? "14" : "16"}
        color="rgba(3, 20, 46, 0.8)"
        fontWeight="600"
      >
        {label}
      </tspan>
      <tspan
        x={centerX}
        dy={isMobile ? "20" : "30"}
        fontSize={isMobile ? "20" : "32"}
        fontWeight="700"
        color="rgba(3, 20, 46, 1)"
      >
        {total}
      </tspan>
    </text>
  );
};
